import React from 'react'
import { Button, Col, Dropdown, Tab,Nav, Form, Modal, Row, Spinner } from 'react-bootstrap'
import axios,{AdminApi}  from '../../../config/axios'
import { tick1 } from "../../../assets/img"
import { BankSvg,sign,wallClock, stamp} from "../../../assets/images"
import message, {getHelpText} from '../../../utils/mesaages';

import { TimePicker, DatePicker } from 'antd';
import moment from "moment";
import { Switch, Tooltip } from 'antd';
// import {CheckCircleOutlined, ClockCircleOutlined,StopOutlined } from '@ant-design/icons';
import BankDetailsModal from '../view/BankDetailsModal'
import BankCardDetails from '../view/BankCardDetails'
import  {LGspinner}  from "../../../assets/images";
import bluesnapForm from '../../../assets/js/bluesnapgateway'
import LoadingOverlay from "react-loading-overlay";
import CustomImageLoader from "react-custom-image-loader.";
import { Link } from "react-router-dom";
import UpdateBankDetailsModal from "../view/UpdateBankDetailsModal";


let userdata = JSON.parse(localStorage.getItem('userdata'))
class ConsumerPayment extends React.Component {

  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = {
      showmodal: false,
      cardtype: '',
      visa: false,
      debit: false,
      cardnumber: '',
      name: '',
      date: '',
      month: '',
      year: '',
      expiryDate: moment().add(1,'months'),
      cvc: '',
      address: '',
      currency: '',
      primarycard: false,
      vendorId: "",
      kyc_status: "",
      country:"",
      rejecttext:null,
      errors: {
        cardnumber: '',
        name: '',
        month: '',
        year: '',
        cvc: '',
        address: '',
        currency: '',
        expiryDate: '',
        primarycard: '',
      },
      gatewayDetails: {},
      savecardloader: false,
      paymentloader: true,
      carddetails: null,
      bankDetails: null,
      deleteloader: false,
      deletecarddata: '',
      deletcardconfirmmodal: false,
      primarycardconfirmmodal: false,
      primarybankconfirmmodal: false,
      primarycarddata: '',
      primarybankdata: '',
      tabOpend: "card",
      key: "card",
      bankdetails: null,
      // vendor details state
      vendorBankDetails: null,
      accountNumber: "",
      accountName: "",
      accountBankname: "",
      bankId: "",
      payoutType: "",
      payoutCurrency: "",
      bankAddress: "",
      // 
      showBankmodal: false,
      accountIFSC:'',
      defaultAccount:false,
      // bankerrors: {
      //   accountNumber:'',
      //   accountName:'',
      //   accountIFSC:'',
      //   accountBankname:'',
      // },
      deletbankconfirmmodal: false,
      deletebankddata: '',
      primaryaccountdata: '',
      primarybankconfirmmodal: false,
      strip_cus:'',
      pfToken:'',
      loaderToken:false,
      vendor_create_help: "",
      kycPerson:null
      
    }
    
  }

  

  componentWillReceiveProps(newProps,prevProps)
  {
    if(newProps.tab!=prevProps.tab)
    {
      this.setState({ key: 'kyc' });
    }
  }

  componentDidUpdate = (prevProps) => {
    console.log("props changed")
    if(prevProps !== this.props) {
      console.log("props changed2")
      if(this.props.scrollToPayment !== ""){
        this.setState({ key: "kyc" });
      }
    }
  }



  async componentDidMount() {
      if(this.props.scrollToPayment !== ""){
        this.setState({ key: "kyc" });
      }
    // this.fetchCustomerId()
    this.fetchSubscriptionStatus()
    this.fetchcards()
    this.fetchBanks()
    // this.fetchBankDetails()
    this.fetchVendorId()
    console.log("checkkk",this.state.expiryDate)
    let vendor_create_help = await getHelpText('vendor_create_help')
    this.setState({vendor_create_help})
  }

  // fetchCustomerId = () => {
  //   let userEmail = JSON.parse(localStorage.getItem("userdata")).email;
  //   axios.post(`/strip/get-customer-list`, {email: userEmail})
  //   .then((res) => {
  //     if(res.data.success) {
  //       this.setState({strip_cus: res.data.cus_id})
  //     }
  //   })
  //   .catch((err) => {
  //     console.log("fetch customer id error", err)
  //   })
  // }

  fetchSubscriptionStatus = () => {
    let userid = JSON.parse(localStorage.getItem("userdata")).uid;
    axios.get(`/users/get-subscription-status/${userid}`, {
      headers: {"x-auth": localStorage.getItem('authToken')}
    })
    .then((response) => {
      console.log("subscription status", response)
      const {data} = response
      if(data.success) {
        this.setState({subscriptionFlag: data.flag})
      }
    })
    .catch((err) => {
      console.log("fetch subscription err", err)
    })
  }

  fetchVendorId = () => {
    let userid = JSON.parse(localStorage.getItem("userdata")).uid;
    axios.get(`/users/getVendorId/${userid}`, {
      headers: {"x-auth": localStorage.getItem('authToken')}
    })
    .then(async (res) => {
      if(res.data.success) {
        console.log("vendorDetails",res.data.vendorDetails)
        let vendorDetails = JSON.parse(res.data.vendorDetails[0].all_details)
        this.setState({vendorId: res.data.value, kyc_status: res.data.vendorDetails[0].kyc_status},()=>{
          this.fetchKycDetails()
        })
        this.setState({country: res.data.vendorDetails[0].acc_country,rejecttext:res.data.vendorDetails[0].rejecttext})
        // await this.setVendorBankDetailsState(vendorDetails)
      }
    })
    .catch((err) => {
      console.log("error", err)
    })
  }

  fetchKycDetails = () => {
    let userUID = JSON.parse(localStorage.getItem("userdata")).uid;
    axios.post(`/strip/getPerson`, {acct_no: this.state.vendorId,uid:userUID})
    .then(async (res) => {
      if(res.data.success) {
        this.setState({kycPerson: res.data.data})
        // await this.setVendorBankDetailsState(vendorDetails)
      }
      
    })
    .catch((err) => {
      console.log("error", err)
    })
  }

  setVendorBankDetailsState = async (vendorDetails) => {
    console.log("i am state change", vendorDetails)
    let payoutInfo = vendorDetails.payoutInfo[0];
    await this.setState({
      payoutType: payoutInfo.payoutType,
      payoutCurrency: payoutInfo.baseCurrency,
      accountNumber: payoutInfo.bankAccountId,
      accountName: payoutInfo.nameOnAccount,
      accountBankname: payoutInfo.bankName,
      bankId: payoutInfo.bankId,
      bankAddress: payoutInfo.address
    }, () => {
      console.log("details state", this.state.accountBankname, this.state.accountNumber)
    })
  }  

  tabsctive(j) {
    this.setState({ key: j }, () => {
      
    });
  }

  loadStripeJS(){
    let userdata = JSON.parse(localStorage.getItem('userdata'));
    const id = userdata.uid;

    let self = this;
    let param = {
      url: `/admin/settings/stripe/${id}`,
      method: "GET",
    };
    axios(param)
    .then(async (res) => {

        if(res.data.hasOwnProperty('stripe')){

          const script = document.createElement("script");
          script.src = "https://js.stripe.com/v2/";
          script.async = true;
          script.onload = () => {
            if(res.data.stripe.mode=='live')
            window.Stripe.setPublishableKey(res.data.stripe.live.publishable_key);
            else
            window.Stripe.setPublishableKey(res.data.stripe.sandbox.publishable_key);
          }
          document.body.appendChild(script);

             self.setState({gatewayDetails: res.data.stripe})
        }

    })
   
  }
  loadCard=()=> {
    return new Promise((resolve, reject) => {
      let self = this
  
    let errors = this.state.errors
  
    window.Stripe.card.createToken({
                number: this.state.cardnumber,
                cvc: this.state.cvc,
                exp_month: moment(this.state.expiryDate).format('MM'),
                exp_year: moment(this.state.expiryDate).format('YYYY')
              },function(status, response) {
                if (response.error) { 
                  // Show appropriate error to user
                  console.log('stripe err',response)
                  if(response.error.param=='number')
                  {
                    errors.cardnumber = response.error.message
                  }
                  else if(response.error.param=='cvc')
                  {
                    errors.cvc = response.error.message
                  }
                  else if(response.error.param=='exp_month')
                  {
                    errors.expiryDate = response.error.message
                  }
                  else if(response.error.param=='exp_year')
                  {
                    errors.expiryDate = response.error.message
                  }
                  self.setState({errors})
                  reject()
                  
                } else {
                  // Get the token ID:
                  var token = response.id;
                  console.log('stripe response',response)
                  resolve(response)
                  // Save token mapping it to customer for all future payment activities
                }
              });
      })
  };
  


 


  fetchcards = () => {
    this.setState({ paymentloader: true })
    console.log('enter fetch cards')
    let self = this;
    let param = {
      url: "/consumer/getpaymentmethodcard",
      method: "GET",
      headers: {
        "X-Auth": localStorage.getItem('authToken'),
      },
    };

    console.log('param', param)
    axios(param)
      .then(async (res) => {
        this.setState({ paymentloader: false })
        if (res.data.success) {
          this.setState({ carddetails: res.data.cards, strip_cus: res.data.customer_id === null ? "" : res.data.customer_id})
          if(res.data.cards.length>0)
          {
            // this.setState({strip_cus:res.data.cards[0].strip_cus},()=>{
            //   console.log('strip_cus',this.state.strip_cus)
            // })

          }
          else {
            this.setState({primarycard: true})
          }
          console.log('getpaymentmethodcard res', res)
        }
      })
      .catch((error) => {
        console.log("fetch error");
        console.log(error);
        //toast("Error getting profile data", { type: "error" });
      });
  }
  fetchBanks = () => {
    this.setState({ paymentloader: true })
    console.log('enter fetch cards')
    let self = this;
    let param = {
      url: "/consumer/getpaymentmethodBankCard",
      method: "GET",
      headers: {
        "X-Auth": localStorage.getItem('authToken'),
      },
    };

    console.log('param', param)
    axios(param)
      .then(async (res) => {
        this.setState({ paymentloader: false })
        if (res.data.success) {
          this.setState({ bankDetails: res.data.cards })
          if(res.data.cards.length>0)
          {
          
           

          }
          console.log('nankdetails res', res)
        }
      })
      .catch((error) => {
        console.log("fetch error");
        console.log(error);
        //toast("Error getting profile data", { type: "error" });
      });
  }


  // fetchBankDetails = () => {
  //   this.setState({ paymentloader: true })
  //   console.log('enter fetch cards')
  //   let self = this;
  //   let param = {
  //     url: "/consumer/getbankdetails",
  //     method: "GET",
  //     headers: {
  //       "X-Auth": localStorage.getItem('authToken'),
  //     },
  //   };

   
  //   axios(param)
  //     .then(async (res) => {
  //       this.setState({ paymentloader: false })
  //       if (res.data.success) {
  //         this.setState({ bankdetails: res.data.bank })
  //         console.log('bank res', res)
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("fetch error");
  //       console.log(error);
  //       //toast("Error getting profile data", { type: "error" });
  //     });
  // }

  cardmodal = async() => {
    console.log('enter')
    let {errors} = this.state
    errors['cardnumber'] = ''
    errors['name'] = ''
    errors['cvc'] = ''
    errors['expiryDate'] = ''
    this.setState({errors})
    //await this.setState({cardnumber: '',cvc:'', primarycard: false, expiryDate:moment().add(1,'months'),name:''})
    await this.setState({cardnumber: '',cvc:'', primarycard: this.state.carddetails.length > 0 ? false : true, expiryDate:moment(),name:''})
    console.log("modal opened", this.state.primarycard)
    this.setState({ showmodal: true},()=>{
      if(this.state.showmodal)
      this.loadStripeJS()
    })
  }

  // bankmodal = async() => {
  //   console.log('enter1')
  //   let {bankerrors} = this.state
  //   bankerrors['accountNumber'] = ''
  //   bankerrors['accountName'] = ''
  //   bankerrors['accountIFSC'] = ''
  //   bankerrors['accountBankname'] = ''
  //   this.setState({bankerrors})
  //   await this.setState({ defaultAccount: false, accountNumber:''})
  //   this.setState({ showBankmodal: true})
  // }

  
  closemodal = () => {
    this.setState({ showmodal: false })
  }

  closebankmodal = () => {
    this.setState({ showBankmodal: false })
  }
 



  setvalue = async(value, field) => {
    let numbers = /^[0-9]*$/;
    let f = field
    this.handleError(field, value);

    if(field === 'cardnumber' && value.length>16)
    {
      
      this.setState({ cardnumber: this.state.cardnumber })
    }
    else
    {
      if (field === 'cardnumber' && numbers.test(value)) {
        this.setState({ cardnumber: value })
      }
      else {
        this.setState({ cardnumber: this.state.cardnumber })
      }
    }
  


    
    if (field === 'name') this.setState({ name: value })
    if (field === 'expiryDate') {
      await this.setState({ expiryDate: value })
    }

    //if (field === 'cvc') this.setState({ cvc: value })

    

    if(field === 'cvc' && this.isValidCVC(value))
    {
      this.setState({ cvc: value })      
    }
    else if(field === 'cvc')
    {
      this.setState({ cvc: this.state.cvc })
    }

    if (field === 'address') this.setState({ address: value })
    if (field === 'currency') this.setState({ currency: value })

    if (field === 'primarycard') this.setState({ primarycard: value })

  }


  
  // setvalueBankDetails = async(value, field) => {
  //   let numbers = /^[0-9]*$/;
  //   let f = field
  //   this.handleBankError(field, value);

    
  //   if (field === 'accountNumber' && numbers.test(value)) {
  //     this.setState({ accountNumber: value })
  //   }
  //   else {
  //     this.setState({ accountNumber: this.state.accountNumber })
  //   }
  //   if (field === 'accountName') this.setState({ accountName: value })
  //   if (field === 'accountIFSC') this.setState({ accountIFSC: value })
  //   if (field === 'accountBankname') this.setState({ accountBankname: value })
  
  //   if (field === 'defaultAccount') this.setState({ defaultAccount: value })

  // }
  isValidCVC = (value) => {
      
    let isValid = true;
    if(!value || value === "") return isValid;

    try {
      if(value.length > value.trim().length) isValid = false;
      else if(value.length > 4 || value.includes('.')) isValid = false;
      else {

        let n = Number(value)
        if(!n) isValid = false;
  
      }

    } catch (error) {
      console.log("Invalid CVC");
      isValid = false;
    }

    return isValid;
  }
  
//before stripe
  // handleError = (name, value) => {
  //   console.log('name' , name)
  //   console.log('value' , value)

  //   let errors = this.state.errors;
  //   switch (name) {
  //     case 'cardnumber':
  //       // errors.cardnumber =
  //       //   value.length >= 15
  //       //     ? ''
  //       //     : 'Card number minimum 15 digits!';
  //       // if (value === '') {
  //       //   errors.cardnumber = 'Card number required'
  //       // }
  //       errors.cardnumber = errors.cardnumber === 'false' ? 'This Field is required':errors.cardnumber
  //       break;
  //     case 'name':
  //       if (value === '') {
  //         errors.name = 'Card holder name required'
  //       } else {
  //         errors.name = ''
  //       }
  //       break;

  //     case 'expiryDate':
  //       // if (value === null) {
  //       //   errors.expiryDate = 'Expiry date is required'
  //       // } else {
  //       //   errors.expiryDate = ''
  //       // }
  //       errors.expiryDate = errors.expiryDate === 'false' ? 'This Field is required':errors.expiryDate
  //       break;

  //     case 'cvc':
  //       // errors.cvc =
  //       //     value.length >=3
  //       //     ? ''
  //       //     : 'CVC accepts minimum 3 digits!';

  //       // if (value === '' || value.length < 3) {
  //       //   errors.cvc = 'CVC Required'
  //       // } else {
  //       //   errors.cvc = ''
  //       // }
  //       errors.cvc = errors.cvc === 'false' ? 'This Field is required':errors.cvc
  //       break;
        

  //     default:
  //       break;
  //   }

    
  //   this.setState({ errors, [name]: value }, () => {
  //     console.log(errors)
  //     // if(typeof(callback) ===  "function") {
  //     //   callback()
  //     // }
  //   })
  // }


  handleError = (name, value) => {
    console.log('name' , name)
    console.log('value' , value)

    let errors = this.state.errors;
    switch (name) {
      case 'cardnumber':
        errors.cardnumber =
          value.length >= 15
            ? ''
            : 'Card number minimum 15 digits!';
        if (value === '') {
          errors.cardnumber = 'Card number required'
        }
        break;
      case 'name':
        if (value === '') {
          errors.name = 'Card holder name required'
        } else {
          errors.name = ''
        }
        break;

      case 'expiryDate':
        if (value === null) {
          errors.expiryDate = 'Expiry date is required'
        } else {
          errors.expiryDate = ''
        }
        break;

      case 'cvc':
        errors.cvc =
          value.length >=3
            ? ''
            : 'CVC accepts minimum 3 digits!';

        if (value === '') {
          errors.cvc = 'CVC Required'
        }
        break;
        

      default:
        break;
    }

    this.setState({ errors, [name]: value }, () => {
      console.log(errors)
    })
  }


  // handleBankError = (name, value) => {
  //   console.log('name1' , name)
  //   console.log('value1' , value)

  //   let bankerrors = this.state.bankerrors;
  //   switch (name) {
  //     case 'accountNumber':
       
  //       if (value === '') {
  //         bankerrors.accountNumber = 'Account number required'
  //       }else {
  //         bankerrors.accountNumber = ''
  //       }
  //       break;
  //     case 'accountName':
  //       if (value === '') {
  //         bankerrors.accountName = 'Account holder name required'
  //       } else {
  //         bankerrors.accountName = ''
  //       }
  //       break;

  //     case 'accountIFSC':
        
  //       if (value === '') {
  //         bankerrors.accountIFSC = 'IFSC Required'
  //       }else {
  //         bankerrors.accountIFSC = ''
  //       }
  //       break;
  //       case 'accountBankname':
        
  //         if (value === '') {
  //           bankerrors.accountBankname = 'Bank name Required'
  //         }else {
  //           bankerrors.accountBankname = ''
  //         }
  //         break;
        

  //     default:
  //       break;
  //   }

  //   this.setState({ bankerrors, [name]: value }, () => {
  //     console.log(bankerrors)
  //   })
  // }

  validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
      // if we have an error string set valid to false
      (val) => val.length > 0 && (valid = false)
    );
    return valid;
  }

  checkrequiredfields = () => {
    let valid = false;
    if (this.state.cardnumber !== '' &&
    this.state.name !== '' &&
    this.state.cvc !== '' 
    ) {
      valid = true
    } else {
     
      this.handleError('cardnumber' ,this.state.cardnumber)
      this.handleError('name' ,this.state.name)
      this.handleError('cvc' ,this.state.cvc)
      // this.handleError('expiryDate' ,this.state.expiryDate)

    }

    

    return valid
  }

  savecard= (event) => {
    event.preventDefault();
    console.info('Valid Form',this.checkrequiredfields());
    if (this.validateForm(this.state.errors) && this.checkrequiredfields()) {
      
   
        ////submit form we have all required fields
        this.savecard2()
     

    } else {
      console.error('Invalid Form');
      message.error("Please enter all required fields");

    }
  }

  savecard2 = async () => {

    let uID=JSON.parse(localStorage.getItem('userdata')).uid
    let email=JSON.parse(localStorage.getItem('userdata')).email
    this.loadCard().then((resCard)=>{
      console.log('resCard',resCard)
    
      let cardExpYear = moment(this.state.expiryDate).format('YYYY')
      let cardExpMonth = moment(this.state.expiryDate).format('MM')

    let cardData = {
      "cardNumber": this.state.cardnumber,
      cardExpYear,
      cardExpMonth,
      // "cVV" : this.state.cvc,
      email:email,
      firstName:this.state.name,
      strip_token:resCard.id,
      uid:uID
    }
  //  console.log('submit',cardData, this.state.expiryDate)
   // return false
    const hideMessage = message.loading('Please wait while saving your card', 0)
    let currencyVal = localStorage.getItem('currency')
    currencyVal = currencyVal || 'USD'

    this.setState({showmodal: false})
    let url =''
    if(this.state.strip_cus=='')
    {
      url = "/strip/customerCreate"
    }
    else
    {
      url = "/strip/customerUpdate"
      cardData.customer=this.state.strip_cus

    }
    axios
    // .post(AdminApi+"/1stPay/cardToken", cardData)
    .post(url, cardData)
    .then(async (response) => {
      hideMessage()
       let {data, success,err} = response.data;
       let d1=[]
       d1['name'] = this.state.name
       d1['uuid'] = uID
       d1['primarycard'] = this.state.primarycard
       d1['currency'] = currencyVal
       d1['cvc'] = 0//this.state.cvc
       console.log('data',data)
       
       console.log(success)
       if(success){
        Object.assign(data, d1)
            await axios.post('/consumer/addpaymentmethod', {... data })
            message.success('Your card saved successfully.')
            await this.setState({cardnumber: '',cvc:'', primarycard: false, expiryDate:'',name:''})
            this.fetchcards()
            
       }else{
        
        
            message.error(err)
       }
       
    }).catch((e,res)=>{
      console.log(e)
      message.error('Invalid Card Details')
      hideMessage()
    })
    

    })
    .catch((err)=>{
      console.log('pftoken error',err)
      message.error('Error in processing your card. Please recheck the details.')
    })

    
  }

  // saveBankDetails= (event) => {
  //   event.preventDefault();
  //   if (this.validateForm(this.state.bankerrors)) {
      
  //     this.saveBankDetails2()
  //   } else {
  //     console.error('Invalid Form');
  //     message.error("Please enter all required fields");

  //   }
  // }

  // saveBankDetails2 = async () => {

  //   let uID=JSON.parse(localStorage.getItem('userdata')).uid
    
  //   let cardData = {
  //     uuid:uID,
  //     ac_holder_name:this.state.accountName,
  //     ac_number:this.state.accountNumber,
  //     ifsc_code:this.state.accountIFSC,
  //     primary_account:this.state.defaultAccount,
  //     bank_name:this.state.accountBankname,
      
  //   }
  
  //   const hideMessage = message.loading('Please wait while saving your account', 0)
    

  //   this.setState({showBankmodal: false})
   
  //   axios.post('/consumer/addbankdetails',cardData)
  //   .then(async (response) => {
  //     hideMessage()
  //      let {data, success} = response.data;
      
  //      if(success){
          
  //           message.success('Your account saved successfully.')
  //           await this.setState({accountNumber: '',accountName:'', accountIFSC: '', accountBankname:'',defaultAccount:false})
  //           this.fetchBankDetails()
            
  //      }else{
        
        
  //           message.error('Error saving your account.')
  //      }
       
  //   }).catch((e,res)=>{
  //     console.log(e)
  //     message.error('Invalid account Details')
  //     hideMessage()
  //   })
    
  // }

  disabledDate = (value) =>{
    // const form = this.props.form;
   // Can not select days before today and today
    return  value < moment();
  }; 

  deletcardconfirm = async (card) => {
    this.setState({ deletecarddata: card, deletcardconfirmmodal: true });
  }

  deletcardcancel = async () => {
    this.setState({ deletecarddata: '', deletcardconfirmmodal: false });
  }

  deletcard = async () => {

    this.setState({ deleteloader: true, deletcardconfirmmodal: false });
    const hideMessage = message.loading('Please wait', 0)
    await axios.post('/consumer/deletepaymentcard', { card: this.state.deletecarddata, user: localStorage.getItem('userdata') }).then((res) => {
      this.setState({ deleteloader: false, });
      if (res.data.success) {
        hideMessage()
        this.fetchcards()
        message.success('Card deleted successfully')

        // this.setState({ carddetails: res.data.card.reverse() });

      } else {
        hideMessage()
        message.error('Error in deleting card')

      }

    }).catch((err) => {
      hideMessage()
      console.log('err', err)
      this.setState({ deleteloader: false, });
    })
  }



  // deletBankconfirm = async (card) => {
  //   this.setState({ deletebankddata: card, deletbankconfirmmodal: true });
  // }
  // deletbankcancel = async () => {
  //   this.setState({ deletebankddata: '', deletbankconfirmmodal: false });
  // }

  // deletBankAccount = async () => {

  //   this.setState({ deleteloader: true, deletbankconfirmmodal: false });
  //   await axios.post('/consumer/deletebankdetails', { deletebankddata: this.state.deletebankddata, user: localStorage.getItem('userdata') }).then((res) => {
  //     this.setState({ deleteloader: false, });
  //     if (res.data.success) {
  //       message.success('Account deleted successfully')

  //       this.setState({ bankdetails: res.data.card.reverse() });

  //     } else {
  //       message.error('Error in deleting account')

  //     }

  //   }).catch((err) => {
  //     console.log('err', err)
  //     this.setState({ deleteloader: false, });
  //   })
  // }
  
  primarycardconfirm = async (card) => {
    console.log('carddetails',card)

    this.setState({primarycarddata: card,  primarycardconfirmmodal: true });
  }


  

  primarycardcancel = async () => {
    this.setState({ primarycarddata: '', primarycardconfirmmodal: false });
  }


  setPrimaryCard = async () => {

    this.setState({ deleteloader: true, primarycardconfirmmodal: false });
     axios.post('/consumer/set-primary-card', { card: this.state.primarycarddata, user: localStorage.getItem('userdata') })
    .then( async (res) => {
      this.setState({ deleteloader: false, });
     
      if (res.data.success) {
        message.success('Card updated successfully')
       // setTimeout(() => {
       await this.fetchcards()
     // }, 1000);
       // this.setState({ carddetails: res.data.card.reverse() });

      } else {
        message.error('Error in update card')

      }

    }).catch((err) => {
      console.log('err', err)
      this.setState({ deleteloader: false, });
    })
  }

  //// primary bank

  primarybankconfirm = async (card) => {
    console.log('carddetails',card)

    this.setState({primarybankdata: card,  primarybankconfirmmodal: true });
  }
  primarybankcancel = async () => {
    this.setState({ primarybankdata: '', primarybankconfirmmodal: false });
  }
    setPrimaryBank = async () => {

    this.setState({ deleteloader: true, primarybankconfirmmodal: false });
     axios.post('/consumer/set-primary-account', { card: this.state.primarybankdata, user: localStorage.getItem('userdata') })
    .then( async (res) => {
      this.setState({ deleteloader: false, });
     
      if (res.data.success) {
        message.success('Updated successfully')
       // setTimeout(() => {
       await this.fetchBanks()
     // }, 1000);
       // this.setState({ carddetails: res.data.card.reverse() });

      } else {
        message.error('Error in update')

      }

    }).catch((err) => {
      console.log('err', err)
      this.setState({ deleteloader: false, });
    })
  }


  // primarybankconfirm = async (card) => {
  //   console.log('primaryaccountdata',card)

  //   this.setState({primaryaccountdata: card,  primarybankconfirmmodal: true });
  // }
  // primaryBankcancel = async () => {
  //   this.setState({ primaryaccountdata: '', primarybankconfirmmodal: false });
  // }




  render() {

    const {scrollToPayment} = this.props
    
    if(scrollToPayment !== "" && this.ref && this.ref.current === undefined) {

      this.ref.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

    }

    let {accountNumber} = this.state
    accountNumber = accountNumber.replace(/\w(?=\w{4})/g, "*");
   
    return (
      <>
      
          {this.state.showmodal === true ?
            <div style={{ color: 'red' }}>

          <Modal
              // size="xl"
              show={this.state.showmodal}
              onHide={this.closemodal}
              // backdrop="static"
              // keyboard={false}
              style={{ color: 'black' }}
            >
              <LoadingOverlay
                    active={this.state.loaderToken}
                    // spinner={<BounceLoader />}
                    spinner={
                      <div>
                        <CustomImageLoader image={LGspinner} animationType={"pulse"} />
                        <br />
                      </div>
                    }
                    text=""
                  >
              <Modal.Header closeButton>
                <Modal.Title>
                  <h3 >Add Payment Method</h3>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                
                  <Row>
                    <Col>
                      <Form.Group controlId="formBasicPassword">
                      <Form.Control onChange={(e) => this.setvalue(e.target.value, 'cardnumber')} style={{ color: 'black' }} type="text" value={this.state.cardnumber} placeholder='Card Number' />
                        <div style={{ color: 'red' }}>{this.state.errors.cardnumber == '' ? '' : this.state.errors.cardnumber}</div>
                      </Form.Group>
                      {/* key={input}  onChange={(e) => setinputdate(e, input)} */}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group controlId="formBasicPassword">
                        <Form.Control onChange={(e) => this.setvalue(e.target.value, 'name')} style={{ color: 'black' }} type="text" placeholder='Name Of Card Holder' />
                        <div style={{ color: 'red' }}>{this.state.errors.name == '' ? '' : this.state.errors.name}</div>

                      </Form.Group>
                      {/* key={input}  onChange={(e) => setinputdate(e, input)} */}
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6} className="mb-2">
                   

                    <DatePicker disabledDate={this.disabledDate}  onChange={(e) => this.setvalue(e, 'expiryDate')} value={this.state.expiryDate} picker="month"    size="large" format={"MM-YYYY"}   />


                    </Col>
                   
                  
                    <Col md={6} className="mb-2">
                      <Form.Group controlId="formBasicPassword">
                      <Form.Control 
                        onChange={(e) => this.setvalue(e.target.value, 'cvc')} 
                        placeholder='CVC' style={{ color: 'black' }} 
                        type="text" 
                        value={this.state.cvc} 
                        />
                        <div style={{ color: 'red' }}>{this.state.errors.cvc == '' ? '' : this.state.errors.cvc}</div>
                      </Form.Group>
                    </Col>
                  </Row>
                 

                  <Row>
                    <Col>
                      <Form.Group controlId="formBasicCheckbox">
                        <Form.Check style={{paddingLeft:"1.75em"}} checked={this.state.carddetails.length === 0 ? true: this.state.primarycard} onChange={(e) => this.setvalue(e.target.checked, 'primarycard')} type="checkbox" label="Make this your primary card" disabled={this.state.carddetails.length > 0 ? false : true}/>
                      </Form.Group>
                    </Col>

                  </Row>
                </Form>

              </Modal.Body>
              <br />

              <Modal.Footer>
                {this.state.savecardloader === true ? <Spinner animation="grow" variant="primary" /> : ''}
                <Button className="defaultBtn" variant="default" onClick={this.savecard}>Save Card</Button>
              </Modal.Footer>
              </LoadingOverlay>
            </Modal>

            </div>
            : ''}



          {/* {this.state.showBankmodal === true ?
            <div style={{ color: 'red' }}> */}

          {/* <Modal
              // size="xl"
              show={this.state.showBankmodal}
              onHide={this.closebankmodal}
              // backdrop="static"
              // keyboard={false}
              style={{ color: 'black' }}
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <div style={{ color: '#9b59b6' }}>
                    <h3 >Add Bank Details</h3>
                  </div>

                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                
                  <Row>
                    <Col>
                      <Form.Group controlId="formBasicPassword">
                        <Form.Control onChange={(e) => this.setvalueBankDetails(e.target.value, 'accountNumber')} style={{ color: 'black' }}  type="text" value={this.state.accountNumber}  placeholder='Account Number' />
                        <div style={{ color: 'red' }}>{this.state.bankerrors.accountNumber === '' ? '' : this.state.bankerrors.accountNumber}</div>
                      </Form.Group>
                      
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group controlId="formBasicPassword">
                        <Form.Control onChange={(e) => this.setvalueBankDetails(e.target.value, 'accountName')} style={{ color: 'black' }} type="text" placeholder='Name Of Account Holder' />
                        <div style={{ color: 'red' }}>{this.state.bankerrors.accountName === '' ? '' : this.state.bankerrors.accountName}</div>

                      </Form.Group>
                      
                    </Col>
                  </Row>
                  <Row>
                    
                    <Col md={6}>
                    <Form.Control onChange={(e) => this.setvalueBankDetails(e.target.value, 'accountBankname')} style={{ color: 'black' }} type="text" placeholder='Name Of Bank' />

                      <div style={{ color: 'red' }}>{this.state.bankerrors.accountBankname === '' ? '' : this.state.bankerrors.accountBankname}</div>

                    </Col>
                   
                  
                    <Col>
                      <Form.Group controlId="formBasicPassword">
                        <Form.Control onChange={(e) => this.setvalueBankDetails(e.target.value, 'accountIFSC')} placeholder='IFSC' style={{ color: 'black' }} type="text" value={this.state.accountIFSC} />
                        <div style={{ color: 'red' }}>{this.state.bankerrors.accountIFSC === '' ? '' : this.state.bankerrors.accountIFSC}</div>
                      </Form.Group>
                    </Col>
                  </Row>
                 

                  <Row>
                    <Col>
                      <Form.Group controlId="formBasicCheckbox">
                        <Form.Check checked={this.state.defaultAccount} onChange={(e) => this.setvalueBankDetails(e.target.checked, 'defaultAccount')} type="checkbox" label="Make this my default bank" />
                      </Form.Group>
                    </Col>

                  </Row>
                </Form>

              </Modal.Body>
              <br />

              <Modal.Footer>
                {this.state.savecardloader === true ? <Spinner animation="grow" variant="primary" /> : ''}
                <Button variant="primary" onClick={this.saveBankDetails}>Save Bank</Button>
              </Modal.Footer>
            </Modal> */}
            {/* <BankDetailsModal 
              showBankmodal={this.state.showBankmodal}
              handleBankModal= {this.closebankmodal}
            /> */}

            {/* </div>
            : ''} */}
    

        {this.state.paymentloader === true ? <Spinner animation="grow" variant="primary" />

          :





          // <div className="col-md-8 col-lg-9">
          <>

            {this.state.deleteloader === true ?
              <Spinner animation="grow" variant="primary" />
              : ''}
                <Modal
              show={this.state.deletcardconfirmmodal}
              onHide={this.deletcardcancel}
              backdrop="static"
              style={{color:'black'}}
              // keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Delete Confirmation</Modal.Title>
              </Modal.Header>
              <Modal.Body>
               Are you sure you want to delete card ?.
        </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={this.deletcardcancel}>
                  Cancel
          </Button>
                <Button variant="primary" onClick={this.deletcard}>Yes</Button>
              </Modal.Footer>
            </Modal>

            <Modal
              show={this.state.deletbankconfirmmodal}
              onHide={this.deletbankcancel}
              backdrop="static"
              style={{color:'black'}}
              // keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Delete Confirmation</Modal.Title>
              </Modal.Header>
              <Modal.Body>
               Are you sure you want to delete account ?.
        </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={this.deletbankcancel}>
                  Cancel
          </Button>
                <Button variant="primary" onClick={this.deletBankAccount}>Yes</Button>
              </Modal.Footer>
            </Modal>

              
            <Modal
              show={this.state.primarycardconfirmmodal}
              onHide={this.primarycardcancel}
              backdrop="static"
              style={{color:'black'}}
              // keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Primary Card</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.state.primarycarddata.primarycard==='1'?
                'Are you sure you want to remove this as your primary card?'
                :'Are you sure you want to set this card as primary card?'
                
              }
                
        </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={this.primarycardcancel}>
                  Cancel
          </Button>
                <Button variant="primary" onClick={this.setPrimaryCard}>Yes</Button>
              </Modal.Footer>
            </Modal>

            <Modal
              show={this.state.primarybankconfirmmodal}
              onHide={this.primarybankcancel}
              backdrop="static"
              style={{color:'black'}}
              // keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Default bank account</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.state.primaryaccountdata.primary_account==='1'?
                'Are you sure you want to remove this as your default account?'
                :'Are you sure you want to set this account as default?'
                
              }
                
        </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={this.primarybankcancel}>
                  Cancel
          </Button>
                <Button variant="primary" onClick={this.setPrimaryBank}>Yes</Button>
              </Modal.Footer>
            </Modal>

            {/* <div className="heading text-center">
              <h3>Payment Methods</h3>
              <span className="R_divider"></span>
            </div> */}
            <div className="userBookingList" ref={elm => {
              this.ref = elm
            }}>
            <Tab.Container
              className="userbooking_tabs"
              id="left-tabs-example"
              defaultActiveKey="first"
              transition={false}
              // id="noanim-tab-example"
              activeKey={this.state.key}
              onSelect={(k) => this.tabsctive(k)}
            >
              <Nav variant="tabs" defaultActiveKey="bank" className="navTab">
                <Nav.Item>
                  <Nav.Link eventKey="card" onClick={() => {this.setState({tabOpend: 'card'})}}>Card Details</Nav.Link>
                </Nav.Item>
                <Nav.Item className="tour-bank-details">
                  <Nav.Link  eventKey="kyc" onClick={() => {this.setState({tabOpend: 'kyc'})}}>KYC Details</Nav.Link>
                </Nav.Item>
                <Nav.Item className="tour-bank-details">
                  <Nav.Link  eventKey="bank" onClick={() => {this.setState({tabOpend: 'bank'})}}>Bank Details</Nav.Link>
                </Nav.Item>
               
              </Nav>

            <Tab.Content>

              <Tab.Pane eventKey="card">
              {this.state.key == "card" ? (
              <> 
            <div className="searchHead">
              <div className="searchHeading">
                <h3><img
                  alt="IMG_LG/"
                  width="50px"
                  //  src="images/credit-card.svg"
                  src="data:image/jpeg;base64,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"
                /> My Payment Methods</h3>
              </div>
              <button data-toggle="modal" data-target="#addPayment" onClick={this.cardmodal} className="defaultBtn">Add Payment Methods</button>
            </div>

            {this.state.carddetails !== null ?
              this.state.carddetails.map((card) => {
                return <div className="cardDetails mt-5">
                  <div className="cardHeading mt-5">
                    <h3>{card.cardcompany ? card.cardcompany : ''} {card.cardnumber}</h3>
                    {card.primarycard=='1' && (
                      <p className="ml-2" style={{color:'green'}}><b>Primary Card</b></p>

                    )}
                    
                    <div className="cardAction">
                      {/* <a href="/#">Delete</a> */}
                      {/* <a href="/#">Edit</a> */}
                      {(card.primarycard!='1' || this.state.subscriptionFlag !== true) && (
                      <a href="javascript:void(0)" onClick={() => this.deletcardconfirm(card)}>Delete</a>
                      )}
                    </div>
                  </div>
                  <div className="cardBody">
                  <Col md={12}>
                  
                  <Switch
                  className="float-right"
                   
                   checked={card.primarycard==='1'?true:false}
                    onClick={() => {if(card.primarycard!=='1') this.primarycardconfirm(card)}}
                  />
                   <b className="mr-2 float-right">Set as my primary card</b> 
                  </Col>
                    <div className="cardDItem">
                      <b>Card Holder Name</b>
                      <p>{card.name}</p>
                    </div>
                    <div className="cardDItem">
                      <b>Card Type</b>
                      <p>{card.cardtype}</p>
                    </div>
                    <div className="cardDItem">
                      <b>Expires</b>
                      <p>{card.expirymonth}/{card.expiryyear}</p>
                    </div>
                    {/* <div className="cardDItem">
                      <b>Billing Information </b>
                      <p>{card.address}</p>
                    </div> */}
                    {/* <div className="cardDItem">
                      <b>Currency</b>
                      <p>{card.currency}</p>
                    </div> */}
                  </div>
                </div>


              })
              : ''
            }

            </>) : (
                    <></>
                  )}
            
            </Tab.Pane>

            <Tab.Pane eventKey="kyc" className="tour-kyc-add">
              {this.state.key == "kyc" && 
              <> 
            <div className="searchHead">
              <div className="searchHeading align-titems-center">
              <img
                  alt="IMG_LG/"
                  width="50px"
                  src={BankSvg}
                  
                />
                <div className="d-flex flex-wrap flex-column justify-content-start ml-2">
                    <div className="d-flex">
                      <h3 className="mt-2"> Vendor Details </h3>
                      {this.state.kyc_status !== "0" && (
                        <span>
                            <i><img src={this.state.kyc_status == "1"? sign :
                            this.state.kyc_status == "2"? wallClock :
                            this.state.kyc_status == "3"? stamp : ""} /></i>

                            {this.state.kyc_status == "1"? "Verified" :
                            this.state.kyc_status == "2"? "Pending" :
                            this.state.kyc_status == "3"? "Unverified" : ""}
                        </span>
                      )}
                    </div>
                  
                  {this.state.kyc_status == "3" && this.state.rejecttext != null &&(
                    <small style={{marginBottom:"0px",color:"red"}}><b>{this.state.rejecttext}</b></small>

                  )}
              </div>
                
              </div>
            
              {this.state.vendorId !== null && this.state.vendorId !== "" ? 
                this.state.kyc_status === "0" || this.state.kyc_status === "3" ? (<>
                  
                 
                  <BankDetailsModal
                   showBankmodal={this.state.showBankmodal}
                   handleBankModal= {this.closebankmodal}
                   fetchVendorId= {this.fetchVendorId}
                   country={this.state.country}
                   
                   />
                </>) : (
                  <>
                  {this.state.kyc_status === "2" && (
                     <Tooltip placement="top" title="Please wait your submitted KYC verification checking pending">
                     <span style={{cursor: "not-allowed"}}>
                     <button className="defaultBtn" style={{pointerEvents: "none"}}>
                     Add Customer Details (KYC)
                     </button>
                     </span>
                   </Tooltip>
                   
                  )}
                   
                  
                </>
                ) : (
                  // <Tooltip placement="top" title={this.state.vendor_create_help}>
                  //   <Link className="defaultBtn " 
                  //     to={{pathname: "profile-coach-edit"}}
                  //     style={{cursor: "pointer"}}
                  //   >
                  //     Add Customer Details (KYC)
                  //   </Link>
                  // </Tooltip>
                  <BankDetailsModal
                   showBankmodal={this.state.showBankmodal}
                   handleBankModal= {this.closebankmodal}
                   fetchVendorId= {this.fetchVendorId}
                   country={this.state.country}
                   
                   />
                )

              }              
            </div>

            <div>
              <p><small className="mt-0"><strong>*Note* - Please complete customer details with your personal and banking information. Payment for your services on LifeGuru platform will be made to this bank account.</strong></small></p>
              </div>

              {this.state.vendorId !== null && this.state.vendorId !== "" && this.state.kycPerson != null?
            <div className="cardDetails mt-5">
              
              <div className="cardBody">
              <Col md={12}>
              
              </Col>
                
                <div className="cardDItem">
                  <b>Profile Name</b>
                  <p>{this.state.kycPerson.name !=null && this.state.kycPerson.name!=''? this.state.kycPerson.name : ''}</p>
                </div>
                <div className="cardDItem">
                  <b>Email</b>
                  <p>{this.state.kycPerson.email !=null && this.state.kycPerson.email!=''? this.state.kycPerson.email : ''}</p>
                </div>
                <div className="cardDItem">
                  <b>Phone</b>
                  <p>{this.state.kycPerson.phone !=null && this.state.kycPerson.phone!=''? this.state.kycPerson.phone : ''}</p>
                </div>
                <div className="cardDItem">
                  <b>Address</b>
                  <p>{this.state.kycPerson.address.full !=null && this.state.kycPerson.address.full!=''? this.state.kycPerson.address.full : ''}</p>
                </div>
                {this.state.country.toUpperCase() !== "GB" && (
                  <div className="cardDItem">
                  <b>Country</b>
                  <p>{this.state.kycPerson.address.country !=null && this.state.kycPerson.address.country!=''? this.state.kycPerson.address.country : ''}</p>
                </div>
                )}
                
                <div className="cardDItem">
                  <b>City</b>
                  <p>{this.state.kycPerson.address.city !=null && this.state.kycPerson.address.city!=''? this.state.kycPerson.address.city : ''}</p>
                </div>
                <div className="cardDItem">
                  <b>
                    {/* {this.state.country.toUpperCase() !== "GB"? 'State': 'Country'} */}
                    State/Province/Area/County
                    </b>
                  
                  <p>{this.state.kycPerson.address.state !=null && this.state.kycPerson.address.state!=''? this.state.kycPerson.address.state : ''}</p>
                </div>
                <div className="cardDItem">
                  <b>Zip / Postal Code</b>
                  <p>{this.state.kycPerson.address.zip !=null && this.state.kycPerson.address.zip!=''? this.state.kycPerson.address.zip : ''}</p>
                </div>
                
              </div>
          </div>

              : ''
            }

   
         
              

              
          

            </>}
            
            </Tab.Pane>

            <Tab.Pane eventKey="bank">
            {this.state.key == "bank" && 
              <> 
            <div className="searchHead">
              <div className="searchHeading">
                <h3><img
                  alt="IMG_LG/"
                  width="50px"
                  src={BankSvg}
                  
                /> Bank Details</h3>
                
              </div>
              
             
              <BankCardDetails fetchBanks={this.fetchBanks} bankDetails = {this.state.bankDetails}/>
            </div>

            <div>
              <p><small className="mt-0"><strong>*Note* - Please complete customer details with your personal and banking information. Payment for your services on LifeGuru platform will be made to this bank account.</strong></small></p>
              </div>

            {this.state.vendorId !== null && this.state.vendorId !== "" && this.state.bankDetails !== null?
           
                    this.state.bankDetails.map((bank)=>{

                        let details = JSON.parse(bank.details)
                      return(
                        <div className="cardDetails mt-5">
                            <div className="cardHeading mt-5">
                              <h3>Account Number: {`****${details.last4}`}</h3>
                              {/* {bank.primaryCard=='1' && (
                                <p className="ml-2" style={{color:'green'}}><b>Primary Card</b></p>

                              )} */}
                            </div>
                            <div className="cardBody">
                                    <Col md={12}>
                                    {/* <Switch
                                    className="float-right"
                                    
                                    checked={bank.primaryCard==='1'?true:false}
                                      onClick={() => {if(bank.primaryCard!='1') this.primarybankconfirm(bank)}}
                                    /> */}
                                    {/* <b className="mr-2 float-right">Set as my primary</b>  */}
                                    </Col>
                                      {/* <div className="cardDItem">
                                        <b>Payout Type</b>
                                        <p>{this.state.payoutType}</p>
                                      </div>
                                      <div className="cardDItem">
                                        <b>Payout Currency</b>
                                        <p>{this.state.payoutCurrency}</p>
                                      </div> */}
                                      <div className="cardDItem">
                                        <b>Account Holder Name</b>
                                        <p>{details.account_holder_name}</p>
                                      </div>
                                      <div className="cardDItem">
                                        <b>Bank Name</b>
                                        <p>{details.bank_name}</p>
                                      </div>
                                      <div className="cardDItem">
                                        <b>Routing Number / Sort Code</b>
                                        <p>{details.routing_number}</p>
                                      </div>
                                      {/* <div className="cardDItem">
                                        <b>Bank Address</b>
                                        <p>{this.state.bankAddress}</p>
                                      </div> */}
                                      
                            </div>
                        </div>
                      )
                      

                    })
            :""}

   
         
              

              
          

            </>}
            
            </Tab.Pane>


            </Tab.Content>
            </Tab.Container>
            </div>
            <hr />
          {/* </div> */}
          </>

         

        }







    
</>

    )
  }
}
export default ConsumerPayment 